import { Colors, IcChannel, IcInStore, IcMenuSetting, IcPlus, IcScreen } from 'basic-ui-lib';
import { ReactNode } from 'react';

export enum ETabEnum {
  SCREENS = 'SCREENS',
  PLAYLISTS = 'PLAYLISTS',
  NEWSCREEN = 'NEWSCREEN',
  STORES = 'STORES',
  SETTINGS = 'SETTINGS',
}

export interface IBottomNavConfig {
  label: string;
  link: string;
  icon: ReactNode;
  iconActive: ReactNode;
  isLabelHide?: boolean;
  isAddScreen?: boolean;
}

export const bottomNavConfig: Record<ETabEnum, IBottomNavConfig> = {
  [ETabEnum.SCREENS]: {
    label: 'Screens',
    link: '/screen',
    icon: <IcScreen fill={Colors.neutral.text[3]} width={24} height={24} />,
    iconActive: <IcScreen fill={Colors.secondary[5]} width={24} height={24} />,
  },
  [ETabEnum.PLAYLISTS]: {
    label: 'Playlists',
    link: '/playlist',
    icon: <IcChannel width={24} height={24} fill={Colors.neutral.text[3]} />,
    iconActive: <IcChannel fill={Colors.secondary[5]} width={24} height={24} />,
  },
  [ETabEnum.NEWSCREEN]: {
    label: 'New Screen',
    link: '/new-screen',
    icon: <IcPlus width={24} height={24} fill={Colors.neutral.text[3]} />,
    iconActive: <IcPlus fill={Colors.secondary[5]} width={24} height={24} />,
    isAddScreen: true,
  },
  [ETabEnum.STORES]: {
    label: 'Stores',
    link: '/store',
    icon: <IcInStore width={24} height={24} fill={Colors.neutral.text[3]} />,
    iconActive: <IcInStore fill={Colors.secondary[5]} width={24} height={24} />,
  },
  [ETabEnum.SETTINGS]: {
    label: 'Settings',
    link: '/setting',
    icon: <IcMenuSetting width={24} height={24} fill={Colors.neutral.text[3]} />,
    iconActive: <IcMenuSetting fill={Colors.secondary[5]} width={24} height={24} />,
  },
};
